import {ssoText, useSsoLocale} from '../../../../../../../resources/js/linkspot-ui';
import {ReactNode} from 'react';
export enum AccountSettingsId {
  AccountDetails = 'account-details',
  SocialLogin = 'social-login',
  Password = 'password',
  TwoFactor = 'two-factor',
  LocationAndLanguage = 'location-and-language',
  Developers = 'developers',
  DeleteAccount = 'delete-account',
  Sessions = 'sessions',
}
export function AccountSettingsSidenav(_props: {items?: ReactNode}) {
 useSsoLocale();

 return <nav aria-label={ssoText("계정 설정")} style={{minWidth:160,paddingTop:12}}><a href="#account-details" className="block" style={{marginBottom:20}}>{ssoText("프로필")}</a><a href="#central-account" className="block" style={{marginBottom:20}}>{ssoText("LinkSpot 계정")}</a><a href="#localization" className="block" style={{marginBottom:20}}>{ssoText("언어 및 시간대")}</a></nav>;
}
